export const CULTURE_PROJECT_STAGE_NAME = {
  Intro: 'Intro',
  Values: 'Values',
  Confirm: 'Confirm',
  Success: 'Success',
};

export const PART_OF_SURVEY = {
  DataGroupQuestion: 'DataGroupQuestion',
  KeyAreas: 'KeyAreas',
  WordcloudQuestion: 'WordcloudQuestion',
};

export const CULTURE_PROJECT_PROCESS_FORM_FIELDS = {
  DATA_GROUP_ANSWERS: 'dataGroupAnswers',
  KEY_AREA_ANSWERS: 'keyAreaAnswers',
  SELECTED_WORDS: 'selectedWords',
};

export const PROJECTS_DATA_KEYS = {
  NAME: 'name',
  LAUNCH_DATE: 'launchDate',
  STATUS: 'status',
  PROJECT_TYPE: 'projectType',
  ACTIONS: 'actions',
};

export const ARCHIVED_PROJECT_INFO =
  'This project has been archived. You are unable to change anything in the project.';
export const ACTIVE_CULTURE_PROJECT_INFO =
  'You are unable to change anything in the survey other than the end date once it has launched.';

export const PROJECT_FREQUENCY_TYPE = {
  WEEKLY: 'Weekly',
  MONTHLY: 'Monthly',
};

export const projectOrderedFrequency = [PROJECT_FREQUENCY_TYPE.WEEKLY, PROJECT_FREQUENCY_TYPE.MONTHLY];

export const PROJECT_MONTHLY_FREQUENCY_DATES = {
  SPECIFIC_DATE: 'specific_date',
  SPECIFIC_DAY_OF_WEEK: 'specific_day_of_week',
};

export const PROJECT_MONTHLY_FREQUENCY_TYPE = {
  [PROJECT_MONTHLY_FREQUENCY_DATES.SPECIFIC_DATE]: 'Every specific day of month',
  [PROJECT_MONTHLY_FREQUENCY_DATES.SPECIFIC_DAY_OF_WEEK]: 'Every specific weekday',
};

export const MIN_DATA_GROUP_COUNT = 1;
export const MAX_DATA_GROUP_COUNT = 5;
export const MIN_DATA_GROUP_SEGMENTS_COUNT = 2;
export const MAX_DATA_GROUP_SEGMENTS_COUNT = 10;

export const MIN_KEY_AREAS_COUNT = 2;
export const MAX_KEY_AREAS_COUNT = 4;
export const MIN_KEY_AREA_QUESTIONS_COUNT = 3;
export const MAX_KEY_AREA_QUESTIONS_COUNT = 8;

export const CULTURAL_PROJECT_ERROR_TARGETS = {
  DUPLICATED_DATA_GROUPS: 'duplicatedDataGroups',
  INVALID_DATA_GROUPS: 'invalidDataGroups',
  KEY_AREAS: 'keyAreas',
};

export const CULTURAL_PROJECT_VALIDATION_ERRORS = {
  DUPLICATED_DATA_GROUP_NAMES:
    'Data group question names must be unique. Please rename the highlighted data group questions.',
  DUPLICATED_SEGMENT_TITLES:
    'Segment titles must be unique within a data group question. Please rename the duplicated segments in the highlighted data group questions.',
  INVALID_SEGMENTS_COUNT: `Each data group question must have a minimum of ${MIN_DATA_GROUP_SEGMENTS_COUNT} segments and a maximum of ${MAX_DATA_GROUP_SEGMENTS_COUNT}.`,
  INVALID_KEY_AREA_QUESTIONS_COUNT: `Each key area must have a minimum of ${MIN_KEY_AREA_QUESTIONS_COUNT} survey statements and a maximum of ${MAX_KEY_AREA_QUESTIONS_COUNT}.`,
  DUPLICATED_KEY_AREA_NAMES: 'Key area names must be unique. Please rename the highlighted key areas.',
  DUPLICATED_CULTURAL_PILLARS:
    'Cultural pillar names must be unique within a key area. Please rename the duplicated pillars in the highlighted key areas.',
};

export const DUPLICATED_PROJECT_NAME_WARNING = 'Please check the name of the project';
export const DUPLICATED_PROJECT_LAUNCH_DATE_WARNING = 'Please check the launch date';
export const DUPLICATED_PROJECT_FREQUENCY_WARNING = 'Please check the frequency';

export const CULTURAL_PROJECT_TYPES = {
  PRIVATE: 'Private',
  PUBLIC: 'Public',
};

export const CULTURAL_PROJECT_TYPES_DESCRIPTION = {
  [CULTURAL_PROJECT_TYPES.PRIVATE]:
    'This setting ensures a fully automated process and restricts participation to users added directly to the project',
  [CULTURAL_PROJECT_TYPES.PUBLIC]:
    'This setting creates a public survey with both a QR code and link that anyone can access and take part in',
};

export const CP_KEY_AREA_EVALUATION_COLORS = [
  '#2c2a43',
  '#42578d',
  '#4e6fb3',
  '#5985d8',
  '#6db1f9',
  '#75c4f5',
  '#84ebee',
];

export const PROJECT_ACTION_PLAN = {
  SINGLE: 'single',
  PER_SEGMENT: 'per_segment',
};

export const PROJECT_ACTION_PLAN_LABEL = {
  [PROJECT_ACTION_PLAN.SINGLE]: 'Project Action Plan',
  [PROJECT_ACTION_PLAN.PER_SEGMENT]: 'Action Plan per Project Segment',
};

export const PROJECT_ACTION_PLAN_DESCRIPTION = {
  [PROJECT_ACTION_PLAN.SINGLE]: 'By selecting Project Plan it means there is 1 Action Plan for this project',
  [PROJECT_ACTION_PLAN.PER_SEGMENT]:
    'By selecting Group Segments Plans it means there is an Action Plan generated for each of the segments listed in the group question(s) below',
};
